export const COLORS = {
  primary: '#00258e',      // Deep royal blue
  primaryHover: '#0632cc', // Brighter blue for hover states
  secondary: '#c1c0c0',    // Light gray
  secondaryHover: '#a8a7a7', // Darker gray for hover states
  accent: '#5186fc',       // Bright light blue accent
  error: '#FFD2D2',        // Light red for errors
} as const;

export type ColorKey = keyof typeof COLORS;
